import { render, staticRenderFns } from "./employee-deduct.vue?vue&type=template&id=4b4b28e2"
import script from "./employee-deduct.vue?vue&type=script&lang=js"
export * from "./employee-deduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports